import { render, staticRenderFns } from "./mySubmitDetail.vue?vue&type=template&id=9bb28828&scoped=true"
import script from "./mySubmitDetail.vue?vue&type=script&lang=js"
export * from "./mySubmitDetail.vue?vue&type=script&lang=js"
import style0 from "./mySubmitDetail.vue?vue&type=style&index=0&id=9bb28828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb28828",
  null
  
)

export default component.exports